var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('PageHeader',{attrs:{"page-title":"Your Booking"}}),(_vm.myBooking)?_c('SectionTable',{attrs:{"table-group":_vm.myBooking}}):_vm._e(),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }